import { render, staticRenderFns } from "./CollectionHistory.vue?vue&type=template&id=67069a4a&scoped=true"
import script from "./CollectionHistory.vue?vue&type=script&lang=js"
export * from "./CollectionHistory.vue?vue&type=script&lang=js"
import style0 from "./CollectionHistory.vue?vue&type=style&index=0&id=67069a4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67069a4a",
  null
  
)

export default component.exports